<template>
  <div>

    <template v-if="show === 'index'">
      <div class="row mb-2">
        <div class="col-md-6">
          <input v-model="query.generic" class="input form-control"
                 @keypress.enter="find()"
                 placeholder="Pesquisar por Nome ou Email">
          <search-icon @click="find()" class="icon icon-within"/>
        </div>

        <div v-if="$withPolicy('application', 'users')" class="col-md-6">
          <button
              @click="createUser()"
              class="btn btn-primary btn-lg"
          >
            Cadastrar usuário
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">

          <Table :users="users" @sendDeleteUser="sendDeleteUser" @showUser="showUser"/>

          <div class="row">
            <div class="col-md-12 my-1">
              <Pagination
                v-model="meta.currentPage"
                :total-count="meta.totalCount"
                :total-pages="meta.totalPages"
                @pagination="pagination"
              />
            </div>
          </div>

        </div>
      </div>

    </template>

    <template v-if="show === 'show'">
      <div class="pb-3 pt-3">
        <h5>
          <strong @click="show = 'index'" style="cursor: pointer">
            <arrow-left-icon class="pb-1"/>
            Voltar para a listagem de usuários
          </strong>
        </h5>
      </div>

      <Show :key="showVersion"
            :user-id="user.id"
            @sendDeleteUser="sendDeleteUser"
            @editUser="updateUser"
            @renewToken="renewToken"/>

    </template>

    <Modal v-model="showModalFormUser" width="sm">
      <span slot="header">{{ titleUserForm }}</span>
      <Form @cancelSaveUser="showModalFormUser = false"
            :user="user"
            @saveUser="saveUser"/>
    </Modal>

    <ModalDeleteUser v-if="user" v-model="showModalDeleteUser"
                     :user="user"
                     @deleteUser="deleteAccountUser"/>

  </div>
</template>

<script>
  import GetAccount from '@/mixins/GetAccount'
  import Form from './Form'
  import Modal from '../shares/specialTag/Modal'

  import ModalDeleteUser from '@/components/user/ModalDeleteUser'
  import ModelMapper from '@/mixins/ModelMapper'
  import Pagination from '@/components/shares/specialTag/Pagination'

  import Show from './Show'
  import Table from './Table'
  import User from '@/models/User'

  import { SearchIcon, ArrowLeftIcon } from 'vue-feather-icons'

  export default {
    components: { ArrowLeftIcon, Form, Modal, ModalDeleteUser, Pagination, SearchIcon, Show, Table },
    computed: {
      users() {
        return this.getModels || []
      }
    },
    created() {
      this.order.push('id', 'asc')
      this.includes.push('account_user', 'policies', 'permission_groups')

      // O filtro por grupo é resolvido no servidor (q[group_id]); filtrar a
      // página carregada mentiria na paginação.
      const groupId = this.$route.query.group
      if (groupId) this.query.groupId = groupId

      if (this.showUserByRoute(this.$route))
        return

      this.find()
    },
    data: () => ({
      nameModel: 'User',
      show: 'index',
      showVersion: 0,
      showModalDeleteUser: false,
      showModalFormUser: false,
      titleUserForm: '',
      user: null
    }),
    methods: {
      createUser() {
        this.titleUserForm = 'Cadastrar usuário'
        this.user = User.build({ account_user: { role: 'member' } })
        this.showModalFormUser = true
      },
      deleteAccountUser(user) {
        this.openLoad()
        const id = user.accountUserId || user.accountUser.id

        this.axios.delete(`account_users/${id}`)
          .then(() => this.updateUserInIndex())
          .then(() => this.$notify.add('Usuário excluído desta conta com sucesso!'))
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeLoad())
      },
      find() {
        this.asyncTemplateSelect()
      },
      reloadShow() {
        this.showModalFormUser = false
        this.showVersion++
      },
      renewToken(user) {
        this.openLoad()
        this.axios.put(`/account_users/${user.accountUser.id}/renew_token`)
          .then(response => user.accountUser.apiToken = response.data.api_token)
          .then(() => this.$notify.add('Novo token gerado'))
          .finally(() => this.closeLoad())
      },
      saveUser(user) {
        this.asyncTemplateSave(user, {
          after: () => {
            if (this.show === 'show') this.reloadShow()
            else this.updateUserInIndex()
            this.$notify.add('Usuário salvo com sucesso!')
          }
        })
      },
      sendDeleteUser(user) {
        this.user = user
        this.showModalDeleteUser = true
      },
      showUser(user) {
        this.user = user
        this.show = 'show'
      },
      showUserByRoute(route){
        if (route.query.userId) {
          this.user = {id: route.query.userId}
          this.show = 'show'
          delete route.query.userId
          return true
        }
      },
      updateUser(user){
        this.titleUserForm = 'Editar usuário'
        this.user = user
        this.showModalFormUser = true
      },
      updateUserInIndex() {
        this.showModalFormUser = false
        this.showModalDeleteUser = false
        this.show = 'index'
        this.find()
      },
      dataToCamelcase(data) {
        return User.build(data)
      }
    },
    mixins: [ModelMapper, GetAccount],
    name: 'Container',
    watch: {
      $route(route) {
        this.showUserByRoute(route)
      },
      show(value) {
        if (value === 'index')
          this.find()
      }
    }
  }
</script>

<style scoped>

</style>
